// 越南语

export default {
  t1: 'Hoàn thành',
  t5: 'Thanh toán',
  t6: 'Liên kết và ủy quyền',
}
